export const normalizeUserPhone = (phoneNumber) =>
    String(phoneNumber || '').replace(/\D/g, '').replace(/^1/, '').slice(-10);

export const toBoolFlag = (value) => value === true || value === 1 || value === '1';

export const isUserDashboardEligible = (userData) => {
    if (!userData || typeof userData !== 'object') {
        return false;
    }

    const applicantStatusId = Number(userData.ApplicantStatusId);
    const isApprovedOrActive = applicantStatusId === 2 || applicantStatusId === 5;

    return Boolean(
        toBoolFlag(userData.BusinessDetailsComplete) &&
        toBoolFlag(userData.DocumentUploadComplete) &&
        toBoolFlag(userData.ZelleComplete) &&
        toBoolFlag(userData.DisplayLinkCommplete) &&
        isApprovedOrActive
    );
};

export const canAccessHostDashboard = (userData) => {
    if (!userData || typeof userData !== 'object') {
        return false;
    }

    if (toBoolFlag(userData.SelfServeSignup) && toBoolFlag(userData.AccountActivated)) {
        return true;
    }

    return isUserDashboardEligible(userData);
};

export const getUserDashboardRouteState = (userData, phoneNumber, token) => ({
    userId: userData.UserId,
    phoneNumber: normalizeUserPhone(phoneNumber),
    token,
});
